import { render } from "./GolfShowComponent.vue?vue&type=template&id=1bfc7f15"
import script from "./GolfShowComponent.vue?vue&type=script&lang=js"
export * from "./GolfShowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__